var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLink = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.029,
    height: 20.029,
    viewBox: "0 0 20.029 20.029",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a-link{fill:#009af6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.638,164.243,6.8,166.084a2.365,2.365,0,1,1-3.344-3.344l3.7-3.7a2.363,2.363,0,0,1,3.344,0,1.014,1.014,0,0,0,1.449.015L13.1,157.9a5.131,5.131,0,0,0-7.916-.806L1.5,160.776a5.132,5.132,0,1,0,7.258,7.258l3.313-3.313a6.5,6.5,0,0,1-3.436-.478Zm0,0",
    transform: "translate(-0.002 -149.506)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M188.732,1.5a5.138,5.138,0,0,0-7.258,0l-3.313,3.313a6.493,6.493,0,0,1,3.436.478l1.841-1.841a2.365,2.365,0,0,1,3.344,3.344l-3.7,3.7a2.354,2.354,0,0,1-3.112.178,2.318,2.318,0,0,1-.218-.193,1.036,1.036,0,0,0-1.464,0l-1.159,1.159a5.13,5.13,0,0,0,7.916.806l3.683-3.683a5.138,5.138,0,0,0,0-7.258Zm0,0",
    transform: "translate(-170.204 0.001)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLink, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/link.c6acce65.svg";
export { ForwardRef as ReactComponent };